var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Scoreboards } from "../../../../constants";
import { eBranches } from "sb-helpers";
var ServingIndicator = /** @class */ (function (_super) {
    __extends(ServingIndicator, _super);
    function ServingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServingIndicator.prototype.render = function () {
        var onServeTeamClass = this.props.event.score.additionalScores.onServe === this.props.onServe ? "rj-ev-list__indicator--serving" : "";
        return (Scoreboards[eBranches[this.props.event.sportId]]
            ? React.createElement("span", { className: onServeTeamClass + " rj-ev-list__indicator", "data-uat": "span-ev-list-indicator" })
            : "");
    };
    return ServingIndicator;
}(React.PureComponent));
export { ServingIndicator };
//# sourceMappingURL=ServingIndicator.js.map